<template>
  <div>
    <div class="row">
      <div class="col-xl-12 col-lg-6 col-md-6 col-sm-12 col-12">
        <div class="card card-charges pb-3">
          <div class="row">
            <div class="col-8 align-self-center">
              <h2 class="subtitle mb-0">
                {{ formatBookingTypeLabel(serviceType) }}
              </h2>
            </div>
            <div class="col-4 align-self-center text-right"></div>
          </div>

          <table cellspacing="0" cellpadding="1" class="table-prices">
            <tbody>
              <tr>
                <td align="left">
                  <span class="price">Subtotal</span>
                </td>

                <td align="right">
                  <span class="totals">
                    {{ getCurrenSymbolByCurrency(defaultCurrency) }}
                    {{
                      getFormatPrice(
                        getSubTotal(pricing.retail, pricing.includedTaxes),
                        pricing.currencyPrecision
                      )
                    }}
                    {{ defaultCurrency }}</span
                  >
                </td>
              </tr>

              <tr v-if="false">
                <td align="left">
                  <span class="price">Discount</span>
                </td>

                <td align="right">
                  <span class="totals">
                    - {{ getCurrenSymbolByCurrency(defaultCurrency) }}
                    00.00
                    {{ defaultCurrency }}
                  </span>
                </td>
              </tr>

              <tr v-for="item in pricing.includedTaxes">
                <td align="left">
                  <span class="price">{{ item.name }}</span>
                </td>

                <td align="right">
                  <span class="totals">
                    {{ getCurrenSymbolByCurrency(defaultCurrency) }}
                    {{ getFormatPrice(item.retail, pricing.currencyPrecision) }}
                    {{ defaultCurrency }}</span
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div
        class="col-xl-12 col-lg-6 col-md-6 col-sm-12 col-12"
        v-if="showPlatformPartnerFees"
      >
        <div class="card card-charges pb-3">
          <h2 class="subtitle mb-0">
            Platform & Partner Fees
          </h2>

          <table cellspacing="0" cellpadding="1" class="table-prices">
            <thead>
              <tr class="header-table">
                <th align="left" class="text-left">
                  <span class="title-table">Description</span>
                </th>
                <th align="right" class="text-right">
                  <span class="title-table">Percent</span>
                </th>
                <th align="right" class="text-right">
                  <span class="title-table">Total</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="commissions.payment_processor.percentage > 0">
                <td align="left">
                  <span class="price">Stripe Fee</span>
                </td>

                <td align="right">
                  <span class="price">
                    {{ commissions.payment_processor.percentage }} %</span
                  >
                </td>

                <td align="right">
                  <span class="price">
                    {{ getCurrenSymbolByCurrency(defaultCurrency) }}
                    {{ parsePrice(commissions.payment_processor.amount) }}
                    {{ defaultCurrency }}
                  </span>
                </td>
              </tr>
              <tr v-if="commissions.platform.percentage > 0">
                <td align="left">
                  <span class="price">Partner Commission</span>
                </td>

                <td align="right">
                  <span class="price">
                    {{ commissions.platform.percentage }}%</span
                  >
                </td>

                <td align="right">
                  <span class="price">
                    {{ getCurrenSymbolByCurrency(defaultCurrency) }}
                    {{ parsePrice(commissions.platform.amount) }}
                    {{ defaultCurrency }}
                  </span>
                </td>
              </tr>
              <tr class="footer-table">
                <td align="left">
                  <span class="totals">Total Fees</span>
                </td>
                <td align="right"></td>
                <td align="right">
                  <span class="totals">
                    {{ getCurrenSymbolByCurrency(defaultCurrency) }}
                    {{
                      parsePrice(
                        getTotalCommissions([
                          commissions.platform.amount,
                          commissions.payment_processor.amount
                        ])
                      )
                    }}
                    {{ defaultCurrency }}</span
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="col-xl-12 col-lg-6 col-md-6 col-sm-12 col-12 mb-3">
        <div class="card box-total">
          <div class="rows-extra">
            <div class="row">
              <div
                class="col-xl-6 col-lg-6 col-md-7 col-sm-7 col-7 align-self-center"
              >
                <span class="subtitle mb-0">TOTAL CHARGES</span>
              </div>

              <div
                class="col-xl-6 col-lg-6 col-md-5 col-sm-5 col-5 text-right align-self-center"
              >
                <span
                  class="subtitle mb-0"
                  :class="pricing.retail < 0 ? 'loss-alert' : ''"
                >
                  {{ getCurrenSymbolByCurrency(defaultCurrency) }}
                  {{
                    getFormatPrice(pricing.retail, pricing.currencyPrecision)
                  }}
                  {{ defaultCurrency }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatBookingTypeLabel } from "../services/format.service";

export default {
  name: "chargesExperiences",
  props: {
    pricing: {
      type: Object,
      required: true
    },
    defaultCurrency: {
      type: String,
      default: ""
    },
    sendPaymentLink: {
      type: Boolean,
      default: false
    },
    commissions: {
      type: Object,
      required: true
    },
    serviceType: {
      type: String,
      default: "experience",
      description: "Type of service (transfer, experience)",
      validator: function(value) {
        return ["transfer", "experience"].includes(value);
      },
      required: false
    }
  },
  data() {
    return {};
  },
  methods: {
    formatBookingTypeLabel,
    getFormatPrice(amount, currencyPrecision) {
      let total = amount / Math.pow(10, currencyPrecision);
      return total.toFixed(2);
    },
    getSubTotal(retail, includedTaxes = []) {
      let taxesAmount = includedTaxes
        .map(item => item.retail)
        .reduce((accumulator, value) => accumulator + value, 0);
      return retail - taxesAmount;
    },
    getCurrenSymbolByCurrency(currency) {
      if (currency === "USD") {
        return "$";
      } else if (currency === "EUR") {
        return "€";
      } else if (currency === "GBP") {
        return "£";
      }
    },
    getTotalCommissions(commissions = []) {
      return commissions.reduce((total, amount) => {
        return parseFloat((total + parseFloat(amount)).toFixed(2));
      }, 0);
    },
    parsePrice(price) {
      return Number.parseFloat(price).toFixed(2);
    }
  },
  computed: {
    showPlatformPartnerFees() {
      const paymentProcessor = this.commissions.payment_processor || {};
      const platform = this.commissions.platform || {};
      return (
        (paymentProcessor.percentage && paymentProcessor.percentage > 0) ||
        (platform.percentage && platform.percentage > 0)
      );
    }
  }
};
</script>
